import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginBenefits = () => {
  const benefits = [
    {
      icon: "Store",
      title: "Virtual Booth Management",
      description: "Customize your booth with videos, brochures, and course details"
    },
    {
      icon: "Users",
      title: "Lead Generation & Tracking",
      description: "Capture and manage student leads with advanced tagging system"
    },
    {
      icon: "MessageSquare",
      title: "Real-time Chat System",
      description: "Engage with prospective students through instant messaging"
    },
    {
      icon: "Video",
      title: "Video Counseling Sessions",
      description: "Conduct 1:1 and group counseling sessions with screen sharing"
    },
    {
      icon: "BarChart3",
      title: "Analytics Dashboard",
      description: "Track booth visits, engagement metrics, and lead performance"
    },
    {
      icon: "Download",
      title: "Lead Export",
      description: "Download student data in CSV format for your CRM"
    }
  ];

  return (
    <div className="space-y-4">
      <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-4 md:mb-6">
        Platform Features
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="flex gap-4 p-4 bg-card rounded-lg border border-border hover:border-primary/30 transition-smooth"
          >
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
                {benefit?.title}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoginBenefits;